import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/Home.vue'

// -----------------------  新资产管理 ----------------------
const myWithdrawNew = r => require.ensure([], () => r(require('@views/myAssetNew/tab/myWithdraw')))
const myBalance = r => require.ensure([], () => r(require('@views/myAssetNew/tab/myBalance')))
const myTeaBalance = r => require.ensure([], () => r(require('@views/myAssetNew/tab/myTeaBalance')))
const mySign = r => require.ensure([], () => r(require('@views/myAssetNew/tab/sign')))
// 青岛出入金页面
const myWithdrawNewQd = r => require.ensure([], () => r(require('@views/myAssetNew/tab/myWithdrawQd')))
const journalAccount = r => require.ensure([], () => r(require('@views/myAssetNew/tab/journalAccount')))
const allFund = r => require.ensure([], () => r(require('@views/myAssetNew/tab/allFund')))
const flowFund = r => require.ensure([], () => r(require('@views/myAssetNew/tab/flowFund')))
const tranferNew = r => require.ensure([], () => r(require('@views/myAssetNew/tab/tranferNew')))
// ------------------------  新公告 --------------
// const myNotice = r => require.ensure([], () => r(require('@views/noticeMsg/myNotice')))

// // 公告src/views/information/informationTab/n
// const Notice = r => require.ensure([], () => r(require('@views/notice/Notice')))
// // const mail = r =>
// // require.ensure([], () => r(require('@views/mail/mail')))
// const NoticeList = r =>
//   require.ensure([], () => r(require('@views/notice/tab/NoticeList')))
const NoticeDetail = r =>
  require.ensure([], () => r(require('@views/notice/tab/NoticeDetail')))
// const FooterDetail = r =>
//   require.ensure([], () => r(require('@views/notice/tab/FooterDetail')))

// 公告
const Notice = r => require.ensure([], () => r(require('@views/information/informationTab/notice.vue')))

// 报表
const reportSystem = r => require.ensure([], () => r(require('@views/reportSystem/reportSystem')))

// 订单
const orderManagement = r => require.ensure([], () => r(require('@views/orderManagement/orderManagement')))
// 订单详情
const orderDetail = r => require.ensure([], () => r(require('@views/orderManagement/orderDetail')))
// 申请退款
const applyRefund = r => require.ensure([], () => r(require('@views/orderManagement/applyRefund')))
// 退款详情
const refundDetail = r => require.ensure([], () => r(require('@views/orderManagement/refundDetail')))

// 店铺数字权益
const creditStore = (r) => require.ensure([], () => r(require('@/views/creditStore/creditStore')))
// 订货中心
const centerHome = (r) => require.ensure([], () => r(require('@/views/orderCenter/centerHome')))
const orderCenter = (r) => require.ensure([], () => r(require('@/views/orderCenter/orderCenter')))
const productDetail = (r) => require.ensure([], () => r(require('@/views/orderCenter/productDetail')))
const productSure = (r) => require.ensure([], () => r(require('@/views/orderCenter/productSure')))
const storeDetail = (r) => require.ensure([], () => r(require('@/views/orderCenter/storeDetail')))
// 订货商城
const mallIndex = (r) => require.ensure([], () => r(require('@/views/equityMall/index')))
const equityMall = (r) => require.ensure([], () => r(require('@/views/equityMall/equityMall')))
const mallDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/mallDetail')))
const mallSure = (r) => require.ensure([], () => r(require('@/views/equityMall/mallSure')))
const eStoreDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/eStoreDetail')))

// 拼团-普通店铺详情
const ptOrdinaryStoreDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/pt/ordinaryStoreDetail')))
// 拼团-普通商品详情
const ptOrdinaryGoodDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/pt/ordinaryGoodDetail')))
// 秒杀列表
const timeLimit = (r) => require.ensure([], () => r(require('@/views/equityMall/ms/timeLimit')))
const timeLimitList = (r) => require.ensure([], () => r(require('@/views/equityMall/ms/timeLimitList')))
const timeLimitDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/ms/timeLimitDetail')))
const sureOrderM = (r) => require.ensure([], () => r(require('@/views/equityMall/ms/sureOrderM/index')))
// 拼团活动
const groupActivity = (r) => require.ensure([], () => r(require('@/views/equityMall/groupActivity/index')))
const groupList = (r) => require.ensure([], () => r(require('@/views/equityMall/groupActivity/groupList')))
// 拼团-普通商品订单
const ptSureOrder = (r) => require.ensure([], () => r(require('@/views/equityMall/pt/ordinarySureOrder')))
// 拼团-服务详情
const serviceDetail = (r) => require.ensure([], () => r(require('@/views/equityMall/pt/serviceDetail')))

// 个人信息
const information = (r) => require.ensure([], () => r(require('@/views/information/information')))
Vue.use(VueRouter)
const routes = [
  // {
  //   path: '/elelogin',
  //   name: 'elelogin',
  //   component: () =>
  //     import ('../views/reglogin/login/eleLogin')
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/login',
    children: [
      {
        path: '/register/:id',
        name: 'register',
        component: () =>
          import ('../views/reglogin/register/Register')
      }, {
        path: '/login',
        name: 'login',
        component: () =>
          import ('../views/reglogin/login/Login')
      },
      {
        path: '/mail',
        name: 'mail',
        component: () =>
          import ('../views/mail/mail')
      },
      // // 公告
      // {
      //   path: '/notice',
      //   name: 'notice',
      //   component: Notice,
      //   redirect: '/notice/noticelist',
      //   children: [{
      //     path: '/notice/noticelist',
      //     name: 'noticelist',
      //     component: NoticeList
      //   },
      //   // {
      //   //   path: '/notice/noticedetail/:articleId',
      //   //   name: 'noticedetail',
      //   //   component: NoticeDetail
      //   // },
      //   {
      //     path: '/notice/FooterDetail/:articleId',
      //     name: 'FooterDetail',
      //     component: FooterDetail
      //   }
      //   ]
      // },
      // 公告列表 ---- 新
      // {
      //   path: '/myNotice',
      //   name: 'myNotice',
      //   component: myNotice,
      //   redirect: '/myNotice/notice/noticelist',
      //   children: [{
      //     path: '/myNotice/notice/noticelist',
      //     name: 'noticelist',
      //     component: NoticeList
      //   }
      //   ]
      // },
      {
        path: '/Notice',
        name: 'Notice',
        component: Notice
      },
      // 报表系统
      {
        path: '/reportSystem/:id?',
        name: 'reportSystem',
        component: reportSystem
      },
      // 订单列表
      {
        path: '/orderManagement/:typeIndex?',
        name: 'orderManagement',
        component: orderManagement
      },
      // 订单详情
      {
        path: '/orderDetail',
        name: 'orderDetail',
        component: orderDetail
      },
      // 退款申请
      {
        path: '/applyRefund',
        name: 'applyRefund',
        component: applyRefund
      },
      // 退款详情
      {
        path: '/refundDetail',
        name: 'refundDetail',
        component: refundDetail
      },
      // 个人中心
      {
        path: '/information/:id?',
        name: 'information',
        component: information
      },
      // 订货中心
      {
        path: '/centerHome',
        name: 'centerHome',
        meta: {
          requireAuth: true
        },
        component: centerHome,
        redirect: '/centerHome/orderCenter',
        children: [{
          path: '/centerHome/orderCenter',
          name: 'orderCenter',
          meta: {
            requireAuth: true
          },
          component: orderCenter
        }]
      },
      // 拼团-商城
      {
        path: '/mallIndex',
        name: 'mallIndex',
        meta: {
          requireAuth: true
        },
        component: mallIndex,
        redirect: '/mallIndex/equityMall',
        children: [
          // 拼团-首页
          {
            path: '/mallIndex/equityMall',
            name: 'equityMall',
            meta: {
              requireAuth: true
            },
            component: equityMall
          },
          // 拼团-店铺详情
          {
            path: '/mallIndex/ptOrdinaryStoreDetail',
            name: 'ptOrdinaryStoreDetail',
            meta: {
              requireAuth: true
            },
            component: ptOrdinaryStoreDetail
          },
          // 拼团-普通商品详情
          {
            path: '/mallIndex/ptOrdinaryGoodDetail',
            name: 'ptOrdinaryGoodDetail',
            meta: {
              requireAuth: true
            },
            component: ptOrdinaryGoodDetail
          },
          // 秒杀列表
          {
            path: '/timeLimit',
            name: 'timeLimit',
            meta: {
              requireAuth: true
            },
            component: timeLimit
          },
          {
            path: '/timeLimitList',
            name: 'timeLimitList',
            meta: {
              requireAuth: true
            },
            component: timeLimitList
          },
          // 秒杀详情
          {
            path: '/timeLimitDetail/:commodityId/:activityId',
            name: 'timeLimitDetail',
            meta: {
              requireAuth: true
            },
            component: timeLimitDetail
          },
          // 秒杀确认订单
          {
            path: '/sureOrderM',
            name: 'sureOrderM',
            meta: {
              requireAuth: true
            },
            component: sureOrderM
          },
          // 拼团列表
          {
            path: '/groupActivity',
            name: 'groupActivity',
            meta: {
              requireAuth: true
            },
            component: groupActivity
          },
          {
            path: '/groupList',
            name: 'groupList',
            meta: {
              requireAuth: true
            },
            component: groupList
          },
          // 普通商品订单
          {
            path: '/ptSureOrder',
            name: 'ptSureOrder',
            meta: {
              requireAuth: true
            },
            component: ptSureOrder
          },
          // 服务详情
          {
            path: '/serviceDetail',
            name: 'serviceDetail',
            meta: {
              requireAuth: true
            },
            component: serviceDetail
          }
        ]
      },
      // 新资产管理
      {
        path: '/myAssetNew',
        name: 'myAssetNew',
        component: () =>
          import ('../views/myAssetNew/MyAsset'),
        redirect: '/myAssetNew/myBalance',
        meta: {
          requireAuth: true
        },
        children: [{
          path: '/myAssetNew/myBalance',
          name: 'myBalance',
          component: myBalance,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/mywithdrawNew',
          name: 'myWithdrawNew',
          component: myWithdrawNew,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/myTeaBalance',
          name: 'myTeaBalance',
          component: myTeaBalance,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/mySign',
          name: 'mySign',
          component: mySign,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/mywithdrawNewQd',
          name: 'myWithdrawNewQd',
          component: myWithdrawNewQd,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/tranferNew',
          name: 'tranferNew',
          component: tranferNew,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/flowFund',
          name: 'flowFund',
          component: flowFund,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/allFund',
          name: 'allFund',
          component: allFund,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/myAssetNew/journalAccount',
          name: 'journalAccount',
          component: journalAccount,
          meta: {
            requireAuth: true
          }
        }
        ] }
    ]
  },
  {
    path: '/notice/noticedetail/:articleId',
    name: 'noticedetail',
    component: NoticeDetail
  },
  {
    path: '*',
    name: 'error',
    component: () =>
      import ('../views/404')
  }, {
    path: '/creditStore',
    name: 'creditStore',
    meta: {
      requireAuth: true
    },
    component: creditStore
  }, {
    path: '/productDetail/:commodityId',
    name: 'productDetail',
    meta: {
      requireAuth: true
    },
    component: productDetail
  }, {
    path: '/mallDetail/:commodityId',
    name: 'mallDetail',
    meta: {
      requireAuth: true
    },
    component: mallDetail
  }, {
    path: '/productSure',
    name: 'productSure',
    meta: {
      requireAuth: true
    },
    component: productSure
  }, {
    path: '/storeDetail',
    name: 'storeDetail',
    meta: {
      requireAuth: true
    },
    component: storeDetail
  }, {
    path: '/eStoreDetail',
    name: 'eStoreDetail',
    meta: {
      requireAuth: true
    },
    component: eStoreDetail
  }, {
    path: '/mallSure',
    name: 'mallSure',
    component: mallSure,
    meta: {
      requireAuth: true
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

// 路由守卫：检查订单详情页和确认订单页刷新
router.beforeEach((to, from, next) => {
  // 检查订单详情页
  if (to.path === '/orderDetail') {
    import('../store').then(store => {
      const orderDetail = store.default.getters.selectOrderDetailGetter
      const hasOrderDetail = orderDetail && orderDetail.orderDetail && orderDetail.orderDetail.orderId
      if (!hasOrderDetail) {
        console.log('检测到刷新订单详情页，跳转到商城首页')
        next('/mallIndex/equityMall')
      } else {
        next()
      }
    })
  } else if (to.path === '/sureOrderM') { // 检查确认订单页
    import('../store').then(store => {
      const orderData = store.default.getters.goodDetailOrderDataGetter
      const hasData = orderData && orderData.goodDetail && orderData.currentPrice
      if (!hasData) {
        console.log('检测到刷新确认订单页，跳转到商城首页')
        next('/mallIndex/equityMall')
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router
